import styled from 'styled-components';

export const Image = styled.img`
  align-self: 'center';
  width: 400;
  height: 100;
`;

export const Container = styled.div`
  background-color: #fff;
  padding: 0;
  margin-bottom: 40px;
  width: 100%;
  height: 100%;
`;

export const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh;
  width: 100vw;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
`;

export const Block = styled.div`
  background: transparent;
  width: 400px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 20px;
  border-radius: 3px;
`;

export const Wrapper = styled.div`
  text-align: ${props => (props.center ? 'center' : 'left')};
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const HomeButtons = styled.button`
  border: none;
  border-radius: 30px;
  width: 180px;
  height: 60px;
  margin-top: ${props => (props.smallMargin ? '0px' : '15px')};
  margin-bottom: 10px;
  margin-right: 15px;
  padding: 15px 18px;
  cursor: pointer;
  color: #fff;
  background-color: #000;
  font-weight: 500;
  background-position: center;
  &:hover {
    background: #ccc radial-gradient(circle, transparent 1%, #616161 1%)
      center/15000%;
  }
  &:active {
    background-color: #ccc;
    background-size: 100%;
    transition: background 0s;
  }
`;

export const SmallButton = styled.button`
  border: none;
  border-radius: 25px;
  width: 160px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 2px 5px;
  cursor: pointer;
  color: #fff;
  background-color: #000;
  font-weight: 500;
  background-position: center;
  &:active {
    background-color: #ccc;
    background-size: 100%;
    transition: background 0s;
  }
`;

export const SignupButton = styled.button`
  border: none;
  border-radius: 3px;
  width: 150px;
  height: 50px;
  margin-top: 0px;
  margin-bottom: 2px;
  padding: 15px 18px;
  cursor: pointer;
  color: #fff;
  background-color: #000;
  font-weight: 500;
  background-position: center;
  &:hover {
    background: #ccc radial-gradient(circle, transparent 1%, #616161 1%)
      center/15000%;
  }
  &:active {
    background-color: #ccc;
    background-size: 100%;
    transition: background 0s;
  }
`;

export const RadioButton = styled.div``;
